









import { Icon } from '@alpha/ink'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Icon
  }
})
export default class ModalFooter extends Vue {
  @Prop({ required: true }) readonly text!: string
}
